import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const StrategyProLayout = lazy(() =>
  import('../components/strategy-pro/StrategyProLayout').then((m) => ({ default: m.StrategyProLayout }))
)
const StratProHubPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.HubPage }))
)
const StratProCockpitPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.CockpitPage }))
)
const StratProScorePage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.ScorePage }))
)
const StratProVisionPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProVisionPage }))
)
const StratProOkrDashboardPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.OkrDashboardPage }))
)
const StratProObjectifsPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.ObjectifsPage }))
)
const StratProKeyResultsPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.KeyResultsPage }))
)
const StratProAlignementPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.AlignementPage }))
)
const StratProBscDashboardPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.BscDashboardPage }))
)
const StratProPerspectivesPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.PerspectivesPage }))
)
const StratProStrategicMapPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StrategicMapPage }))
)
const StratProInitiativesPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.InitiativesPage }))
)
const StratProRoadmapPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.RoadmapPage }))
)
const StratProSwotPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.SwotPage }))
)
const StratProPestelPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.PestelPage }))
)
const StratProBusinessCasePage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProBusinessCasePage }))
)
const StratProRoiPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.RoiPage }))
)
const StratProFrameworksPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProFrameworksPage }))
)
const StratProPortfolioPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.PortfolioPage }))
)
const StratProProgramsPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.ProgramsPage }))
)
const StratProGovernancePage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProGovernancePage }))
)
const StratProReportExecPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProReportExecPage }))
)
const StratProIntegrationPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProIntegrationPage }))
)
const StratProAuditTrailPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProAuditTrailPage }))
)
const StratProSettingsPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProSettingsPage }))
)
const StratProOutilsPage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.StratProOutilsPage }))
)
const StratProCostOptimizationPage = lazy(() =>
  import('../pages/strategy-pro/CostOptimizationPage').then((m) => ({ default: m.CostOptimizationPage }))
)
const StratProOKRCascadePage = lazy(() =>
  import('../pages/strategy-pro').then((m) => ({ default: m.OKRCascadePage }))
)

export const strategyProRoutes: RouteObject[] = [
  {
    path: '/strategy-pro',
    element: <StrategyProLayout />,
    children: [
      { index: true, element: <StratProHubPage /> },

      { path: 'hub', element: <StratProHubPage /> },
      { path: 'cockpit', element: <StratProCockpitPage /> },
      { path: 'score', element: <StratProScorePage /> },
      { path: 'vision', element: <StratProVisionPage /> },
      { path: 'okr', element: <StratProOkrDashboardPage /> },
      { path: 'objectifs', element: <StratProObjectifsPage /> },
      { path: 'key-results', element: <StratProKeyResultsPage /> },
      { path: 'alignement', element: <StratProAlignementPage /> },
      { path: 'bsc', element: <StratProBscDashboardPage /> },
      { path: 'perspectives', element: <StratProPerspectivesPage /> },
      { path: 'strategic-map', element: <StratProStrategicMapPage /> },
      { path: 'initiatives', element: <StratProInitiativesPage /> },
      { path: 'roadmap', element: <StratProRoadmapPage /> },
      { path: 'swot', element: <StratProSwotPage /> },
      { path: 'pestel', element: <StratProPestelPage /> },
      { path: 'business-case', element: <StratProBusinessCasePage /> },
      { path: 'roi', element: <StratProRoiPage /> },
      { path: 'frameworks', element: <StratProFrameworksPage /> },
      { path: 'portfolio', element: <StratProPortfolioPage /> },
      { path: 'programs', element: <StratProProgramsPage /> },
      { path: 'governance', element: <StratProGovernancePage /> },
      { path: 'report-exec', element: <StratProReportExecPage /> },
      { path: 'integrations', element: <StratProIntegrationPage /> },
      { path: 'audit-trail', element: <StratProAuditTrailPage /> },
      { path: 'settings', element: <StratProSettingsPage /> },
      { path: 'outils', element: <StratProOutilsPage /> },
      { path: 'cost-optimization', element: <StratProCostOptimizationPage /> },
      { path: 'okr-cascade', element: <StratProOKRCascadePage /> },
    ],
  },
]
